import React, { useEffect, useState } from 'react';
import FacebookIcon from '@material-ui/icons/Facebook';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import EmailIcon from '@material-ui/icons/Email';
import YouTubeIcon from '@material-ui/icons/YouTube';
import GitHubIcon from '@material-ui/icons/GitHub';
import InstagramIcon from '@material-ui/icons/Instagram';
import { db } from "../lib/init-firebase";
import loader from "../../images/Loading_icon.gif"
import { collection, getDocs } from "firebase/firestore";

const Social = () => {

    const [socialData, setSocialData] = useState({});

    useEffect(() => {
        const socialRef = collection(db, "social");
        getDocs(socialRef)
            .then((response) => {
                const social = response.docs.map((doc) => ({
                    data: doc.data(),
                }));
                setSocialData(social[0].data);
            })
            .catch((error) => console.log(error.message));
    }, []);

    const { facebook, email, github, instagram, linkedin, youtube } = socialData


    return (
        <div className="mt-5 mb-4 ml-2">
            <a target="_blank" href={linkedin}><LinkedInIcon className="svg-icons mr-3 mb-4" /></a>

            <a target="_blank" href={github}><GitHubIcon className="github-icon mr-3 mb-4" /></a>

            <a target="_blank" href={email}><EmailIcon className="svg-icons mr-3 mb-4" /></a>

            <a target="_blank" href={youtube}><YouTubeIcon className="svg-icons mr-3 mb-4" /></a>

            <a target="_blank" href={instagram}><InstagramIcon className="svg-icons mr-3 mb-4" /></a>

            <a target="_blank" href={facebook}><FacebookIcon className="svg-icons mb-4" /></a>
        </div>
    );
};

export default Social;